export default __webpack_public_path__ + "static/media/reset-link-sent.0f1afd24.svg";